/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".main-container[_ngcontent-%COMP%]{padding:1rem 1rem 1rem 0}.main-container-sub[_ngcontent-%COMP%]{font-family:PoppinsRegular,Arial,Helvetica,sans-serif;border:1px solid #ddd;border-radius:1rem}.main-container-sub[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{color:#444}.main-container-sub[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#ff6000;cursor:pointer;font-weight:700}"];
export { styles as styles };
//# sourceMappingURL=error-ticket.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/progress/error-ticket/error-ticket.component.scss.shim.ngstyle.js
// module id = 1616
// module chunks = 26 27 28